import { DSModal } from "@components/design-system/organisms";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mixpanel from "mixpanel-browser";
import React from "react";
import { useLocation } from "react-router";

import { SCRIBENOTE_PRO_FEATURES } from "./constants";
import { handleSubscribe } from "../../../api/Billing";
import ScribblesLocked from "../../../assets/imgs/scribbles-locked.png";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../../constants";

export default function UpgradeModal({
  shouldShow,
  setShouldShow,
  featureName,
}) {
  const location = useLocation();
  const currentPath = location.pathname;
  const handleUpgrade = () => {
    mixpanel.track("Upgrade Plan Clicked", {
      featureName,
    });
    handleSubscribe({
      priceId: UNLIMITED_PRICE_ID_MONTHLY,
      route: currentPath,
    });
  };

  const getTitle = () => {
    if (featureName === "Trial") {
      return "🕒 You have temporary access to Scribenote Pro";
    }
    if (featureName === "Free Plan") {
      return "🔒 You are on the Free Plan";
    }
    if (featureName) {
      return `🔒 ${featureName} is Locked`;
    }
    return "🔒 You are on the Free Plan";
  };

  const getPlanType = () => {
    if (featureName === "Trial") {
      return "a Trial";
    }
    return "the Free Plan";
  };

  return (
    <DSModal
      isOpen={shouldShow}
      onClose={() => setShouldShow(false)}
      title={getTitle()}
      dataTestId="upgrade-modal"
      actions={[
        {
          label: "Maybe Later",
          variant: "cancel",
          onClick: () => setShouldShow(false),
        },
        {
          label: "Upgrade",
          variant: "primary",
          onClick: handleUpgrade,
        },
      ]}
    >
      <div className="flex flex-col items-center space-y-4 px-4">
        <div className="flex flex-col items-center w-full">
          <img
            width="180"
            src={ScribblesLocked}
            alt="Otto Peek"
            className="drop-shadow-lg"
          />
          <p className="text-md text-primary text-center mt-6 mb-2">
            You're using Scribenote on {getPlanType()}. Upgrade to
            <span className="font-semibold text-brand mx-1">
              Scribenote Pro
            </span>
            today to {getPlanType() === "a Trial" && "permanently "}
            access:
          </p>
          <div className="bg-brand-subtle rounded-xl px-6 py-3 w-full space-y-4">
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
              {SCRIBENOTE_PRO_FEATURES.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-3"
                >
                  <div className="shrink-0 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center mt-0.5">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-white text-xs"
                    />
                  </div>
                  <span className="text-primary">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-5">
        <a
          href="https://www.scribenote.com/pricing"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand hover:text-indigo-800 dark:hover:text-indigo-300 underline transition-colors"
        >
          Learn More
        </a>
      </div>
    </DSModal>
  );
}
